import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

import UserCreate from './UserCreate';
import UserEdit from './UserEdit';
import UserList from './UserList';
import UserPasswordReset from './UserPasswordReset';
import UserProfile from './UserProfile';

const UserManagement = (props) => {
    let { path } = useRouteMatch();
    const [lastURLParams, setLastURLParams] = React.useState(new URLSearchParams(window.location.search));
    React.useEffect(() => {
        let existing_URL_search = new URLSearchParams(window.location.search)
        if (parseInt(existing_URL_search.get('tab')) !== 4) return;
        setLastURLParams(new URLSearchParams(window.location.search))
    }, [window.location.search])

    return (
        <Switch>
            <Route path={`${path}/create`}>
                <UserCreate {...props} />
            </Route>
            <Route path={`${path}/permissions`}>
                <UserList setLastURLParams={setLastURLParams} {...props} />
            </Route>
            <Route path={`${path}/:id/password-reset`}>
                <UserPasswordReset {...props} />
            </Route>
            <Route path={`${path}/:id/edit`}>
                <UserEdit {...props} />
            </Route>
            <Route path={`${path}/:id/edit2`}>
                <UserEdit {...props} />
            </Route>
            <Route exact path={`${path}/:id`}>
                <UserProfile lastURLParams={lastURLParams} {...props} />
            </Route>
            <Route exact path={path}>
                <UserList setLastURLParams={setLastURLParams}  {...props} />
            </Route>
        </Switch>
    );
};

export default UserManagement;
